import React from 'react';
import { ReactComponent as CrossIcon } from '../../../../../../../Assests/Svg/cross-primary-blue.svg';
import { ReactComponent as CrossIconDark } from '../../../../../../../Assests/Svg/cross-icon-primary-dark.svg';


import './TaskItemsDueLabel.css'
const TaskItemsDueLabel = (props) => {
    const { title, themeSelected, onCancelTaskItem, subTitle } = props;

    return (
        <>
            <div className={`d-flex justify-content-center align-items-center w-50 text-center ${themeSelected}`}>
                {/* Title + Subtitle stacked vertically */}
                <div className="d-flex flex-column justify-content-center align-items-center me-3">
                    <div className="graphHeading taskItemTitle">{title}</div>
                    {subTitle ? <div className="graphHeading taskItemTitle">{subTitle}</div>: ''}
                </div>

                {/* Cancel Button */}
                <div className="cancelButton my-1" onClick={onCancelTaskItem}>
                    {themeSelected === 'light-mode' ? <CrossIcon /> : <CrossIconDark />}
                </div>
            </div>
        </>

    )
}

export default TaskItemsDueLabel